import Pollo from '../media/img/pollo.jpeg'
import { ConsultaData, RutaProductos, codeNombreProductoURL } from '../componentes/funcionesEspeciales'
import { useEffect, useState } from 'react';

import Card from '../styles/cardPollo.module.css';

function MenuPromociones({ agregarItemCarro }) {
    const [enPromocion, setPromociones] = useState([])
    const getFamilias = () => {
        ConsultaData(`?/web/getPromociones`, {}, 'POST')
            .then(response => {
                //setEnviando(false)
                if (response) {
                    let datos = []
                    response.forEach(item => {
                        datos.push({
                            id: item.id,
                            art_nombre: item.art_nombre,
                            art_descripcion: item.art_descripcion,
                            art_precio_ventaconigv: item.art_precio_ventaconigv,
                            art_imagen: item.art_imagen
                        });
                    })
                    //datos = Object.values(datos)
                    //console.log("ww", datos)
                    setPromociones(datos)
                } else {
                    console.log("ERROR", response)
                }

            })
    }
    useEffect(() => {
        getFamilias()
    }, [])
    const agregarItemCarrito = (producto) => {
        let producto_guardar = {
            id: producto.id,
            nombre: producto.art_nombre,
            imagen: producto.art_imagen,
            //precio_venta: calcularPrecioFinal(producto.valor_venta_base, producto.tipo_igv, producto.moneda),
            precio_venta: producto.art_precio_ventaconigv,
            //talla: producto.talla,
            //color: producto.color,
            //descuento: 0,
            cantidad: 1,
        }
        agregarItemCarro(producto_guardar)
    }
    const abrirProducto = (nombre) => {
        let nombre_del_producto = codeNombreProductoURL(nombre)
        window.open('./producto/' + nombre_del_producto, '_blank')
    }
    return (
        <div>
            <h6 className='p-4 national-bold'>Sírvase a realizar su Pedido</h6>
            <div className="accordion accordion-flush border p-4" id="accordionFlushExample">
                {/* {JSON.stringify(familias)} */}
                <div className='row'>
                    {enPromocion.map((producto, index) => (
                        <div className={ `${Card.cardPollo} col-sm-6 col-md-4 col-lg-3 col-sm-12 meal-type ng-isolate-scope`} key={index}>
                            <a href="#" className="item-details" > Detalles</a>
                            <div className="single-box" >
                                <div className="product-item-img img6" onClick={() => abrirProducto(producto.art_nombre)}>
                                    <div className="ng-scope" >
                                        <img ng-if="imgPurpose=='big'" title="KFC MEGA MIX - 8 PIEZAS"
                                            //src={Pollo}
                                            src={RutaProductos + producto.art_imagen} />
                                    </div>
                                </div>
                                <div className="text-div">
                                    <div className="meal-name">
                                        <div className="row">
                                            <h6 className="uiname-item col pr-0 ng-binding">
                                                {producto.art_nombre}
                                            </h6>
                                            <p className="price-item-small col-auto ng-binding ng-scope">
                                                S/ {producto.art_precio_ventaconigv}
                                            </p>
                                        </div>
                                    </div>
                                    {/* <div className="item-list" >
                                        <span className="ng-binding">
                                            {producto.art_descripcion}
                                        </span>
                                    </div> */}

                                    <div className="">
                                        <button className="btn block item-pricebutton item-pricebutton showMenu ng-binding"
                                            onClick={(e) => { agregarItemCarrito(producto) }}>
                                            Agregar Al Carro
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>


            </div>
        </div>
    )
}
export default MenuPromociones;